enum BackorderBehaviorEnum {
    /**
     * Allow Partial Fill Orders, Create Backorder Automatically
     */
    PARTIAL_FILL = "PARTIAL_FILL",
    /**
     * Create a backorder if unable to fully fill the order
     */
    FULL = "FULL",
    /**
     * Reserve what's possible, but don't create a backorder. We'll manually do that.
     */
    MANUAL = "MANUAL",
}

export default BackorderBehaviorEnum;
